module.exports = __webpack_public_path__ + "img/album05_13.7e0490a9.jpg";